import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataCourier(params) {
	return client.get("api/ecommerce/courier/data", {
		params: params,
	});
}

function exportCourier(params) {
	return client.get("api/ecommerce/courier/export", {
		params: params,
	});
}

function addCourier(params) {
	return client.post("api/ecommerce/courier/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateCourier(params) {
	return client.post("api/ecommerce/courier/update", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteCourier(params) {
	return client.post("api/ecommerce/courier/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataCourier,
	exportCourier,
	addCourier,
	updateCourier,
	deleteCourier,
}